import { Link, useLocation } from 'react-router-dom';

export function NotFoundPage() {
  const location = useLocation();
  return (
    <div className="notfound-page">
      <pre className="notfound-code">{`
  4 0 4
  ─────
  ▁▂▃▅▇█▇▅▃▂▁
`}</pre>
      <h1>Nothing here.</h1>
      <p className="notfound-path">
        <code>{location.pathname}</code> doesn't exist (yet).
      </p>
      <p>
        <Link to="/">← Back to the home page</Link>
      </p>
    </div>
  );
}
